import React, { useState, useEffect } from "react";
import "./ImageGallery.scss";
import LazyImage from "../../LazyImage/LazyImage";
import { GalleryData } from "../../../data/GalleryData";
import GalleryTabs from "./GallertTabs/GalleryTabs";

export default function ImageGallery({ t }) {
  const tabs = [
    { label: t("gallery_category1"), value: "all" },
    { label: t("gallery_category2"), value: "greathall" },
    { label: t("gallery_category3"), value: "crystalhall" },
    { label: t("gallery_category4"), value: "smallhall" },
    { label: t("gallery_category5"), value: "playroom" },
    { label: t("gallery_category6"), value: "catering" },
  ];

  const [activeTab, setActiveTab] = useState("all");
  const [animationKey, setAnimationKey] = useState(0);

  const filtered =
    activeTab === "all"
      ? GalleryData
      : GalleryData.filter((item) => item.category.toLowerCase() === activeTab);

  useEffect(() => {
    setAnimationKey((prev) => prev + 1);
  }, [activeTab]);

  return (
    <div className="image-gallery">
      <GalleryTabs tabs={tabs} selected={activeTab} onSelect={setActiveTab} />
      <div className="image-gallery__content">
        {filtered.map((item) => (
          <div
            key={`${item.id}-${animationKey}`}
            className="image-gallery__item fade-in"
          >
            <LazyImage src={item.image} alt={`Gallery ${item.id}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
